export default "/fonts/vendor/simple-line-icons/Simple-Line-Icons.svg?f1515a459c88508908124cfdab38ced9";